module.exports = __webpack_public_path__ + "static/tjun-4f586659bdd9457efac60cf0c9a8bc8d.jpg";